import type { SafetyInput } from '@brt/shared-types'
import type { AppStore } from '../useAppStore.ts'

export interface SafetySlice {
  safety: SafetyInput
  setSafety: (updates: Partial<SafetyInput>) => void
}

const DEFAULT_SAFETY: SafetyInput = {
  reserveMarginPercent: 0,
  includeReserve: false,
  minimumRuntimeTarget: 0,
  includeTargetCheck: false,
}

type Set = (fn: (state: AppStore) => Partial<AppStore>) => void

export function createSafetySlice(set: Set): SafetySlice {
  return {
    safety: { ...DEFAULT_SAFETY },

    setSafety: (updates) =>
      set((state) => ({
        safety: { ...state.safety, ...updates },
      })),
  }
}

export { DEFAULT_SAFETY }
